import { ReadOnlyModel } from 'core/models/readOnly.model.js';

export var FonctionsModel = ReadOnlyModel.extend({

  defaults: {
    code: "",
    libelle: ""
  }
});